export const payoutStatusTextsPath = 'payouts.payoutStatusLabels';
export function getStatusText(payout, texts) {
    return payout.isPaid() ? payout.amount().isNegative() ? texts.withdrawn() : texts.deposited() : texts.failed();
}
export function getStatusSkin(payout) {
    return payout.isPaid() ? 'success' : 'error';
}
